// Core
import React, { useState } from 'react';
import { Box, Flex, Text, Divider, Grid, Image, useColorModeValue, useColorMode } from '@chakra-ui/react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import { ReactComponent as PlusIcon } from 'assets/svg/plus.svg';

// Components
import Card from 'components/Card/Card';
import ButtonSelector from 'components/ButtonSelector/ButtonSelector';

const Entries = ({ membershipData, membershipPaymentType }) => {
    const [ membership, setMembership ] = useState('elite');

    const bg = useColorModeValue('white', '#0E1633');

    const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    const calculatePercentage = (part, total) => (part / total) * 100;

    return (
        <>
            <ButtonSelector
                buttons={[
                  { key: 'entry', name: 'Entry' },
                  { key: 'premium', name: 'Premium' },
                  { key: 'elite', name: 'Elite' },
                ]}
                selected={membership}
                onSelect={setMembership}
                w={{base: '100%', sm: '361px'}}
                m="0 auto" />

            <Text my="24px" fontWeight="500" textAlign="center">
                The longer you stay, the more FREE entries you get for any giveaway and they never expire!
                <br />
            </Text>
            <Box maxW="860px" m="0 auto" position="relative">
                { membershipData?.map((item, index) => (<>
                    { item?.paymentType === membershipPaymentType && item?.type === membership && ( <>
                        {[1, 2, 3, 4, 5].map((_, index) => (
                        <Flex key={index} gap={{base: '12px', sm: '21px'}} alignItems="center" mb="16px" zIndex="1">
                            <Text variant="title-md" fontWeight="700" whiteSpace="nowrap" fontStyle="italic">
                                { membershipPaymentType === 'monthly' ? 'Month' : 'Year' } {index + 1}
                            </Text>
                            <Box
                                borderRadius="full"
                                bg={bg}
                                h={{base: '40px', sm: '56px'}} 
                                p="8px"
                                p={{base: '6px', sm: '8px'}} 
                                alignItems="center"
                                w="100%"
                                position="relative"
                                overflow="hidden"
                                transition="0.3s all"
                            >
                                <Flex
                                    w={calculatePercentage(item?.entries * (index+1), item?.entries * 5) + '%'}
                                    p={{base: '2px 2px 2px 8px', sm: '4px 4px 4px 12px'}} 
                                    transition="0.3s all"
                                    borderRadius="full"
                                    bg="linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)"
                                    boxShadow={ isDark ? '0px 1px 22.4px 0px rgba(9, 155, 255, 0.60)' : 'unset'}
                                    justifyContent="space-between"
                                    alignItems="center">
                                    <Text variant="header" fontSize={{base: '20px', sm: '24px'}} color="white">{item?.entries*(index+1)}</Text>
                                    <Box w={{base: '24px', sm: '32px'}} h={{base: '24px', sm: '32px'}} 
                                        bg="white" borderRadius="full" p={{base: '4px 0px', sm: '8px 4px'}}><PlusIcon fontSize={{base: '10px', sm: '16px'}} /></Box>
                                </Flex>

                                { isDark ? <Lines className="abstract-lines" style={{ zIndex: 1, top: '-247px' }} />
                                : <LinesWhite className="abstract-lines" style={{ zIndex: 1, top: '-247px', opacity: 0.3 }} /> }
                            </Box>
                        </Flex>))}
                    </>)}
                </>))}

                { isDark && <Box bg="#099BFF" zIndex="-1" filter="blur(100px)" top="10%" borderRadius="100%" m="0 auto" w="100%" h="270px" position="absolute" /> }
            </Box>

        </>
    );
};


export default Entries;